import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { UserRole } from '../types';
import { Loader2 } from 'lucide-react';
interface ProtectedRouteProps {
  children: React.ReactNode;
  allowedRoles?: UserRole[];
}
export function ProtectedRoute({
  children,
  allowedRoles
}: ProtectedRouteProps) {
  const {
    user,
    isLoading
  } = useAuth();
  const location = useLocation();
  if (isLoading) {
    return <div className="min-h-screen flex items-center justify-center bg-gray-50" data-id="element-174">
        <Loader2 className="w-8 h-8 animate-spin text-blue-600" data-id="element-175" />
      </div>;
  }
  if (!user) {
    return <Navigate to="/login" state={{
      from: location
    }} replace data-id="element-176" />;
  }
  if (allowedRoles && !allowedRoles.includes(user.role)) {
    // Redirect to appropriate dashboard based on role
    const dashboardMap: Record<UserRole, string> = {
      ADMIN: '/admin',
      CHAUFFEUR: '/driver',
      DEPOT: '/depot'
    };
    return <Navigate to={dashboardMap[user.role]} replace data-id="element-177" />;
  }
  return <>{children}</>;
}